import React from 'react';
import Loader from './../components/Utilities/Loader';
import { Link} from 'react-router-dom';
class Home extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            sessions: []
        }
        window.isHomePage = true;
    }

    createSession = async() => {
        let res = await window.sdk.session().createOneToOne();
    
        this.setState({
          sessions : res
        });
    }

    destroySession = async() => {
        if(window.confirm('Are you sure ?')){
            await window.sdk.session().destroyOneToOne(this.state.sessions[0].onetoone.token);
            this.setState({
                sessions : []
              });
        }
    }

    open(session){
        window.page = window.open("/onetoone/"+session.onetoone.token+"/"+session.token,"One To One HOCOIA - " + session.name,"menubar=no, status=no, scrollbars=no, menubar=no, width="+window.screen.width+", height="+window.screen.height);
    }

    render(){
        return(
            <React.Fragment>
                <button onClick={this.createSession}>CREATE SESSION</button>
        
                {this.state.sessions && this.state.sessions.length > 0 && 
                   <div>
                        {this.state.sessions.map(session => 
                        <React.Fragment>
                            <a href={"/onetoone/"+session.onetoone.token+"/"+session.token} target="_blank"> {session.name}</a>
                            <div key={ session.id } onClick={() => {this.open(session)}}>
                               {session.name} IN A POPUP
                            </div>
                            </React.Fragment>
                        )}
                         <button onClick={this.destroySession}>DESTROY THIS SESSION</button>
                    </div>
                   
                }
                <Loader />
            </React.Fragment>
        )
    }
}

export default Home;